import type { FC } from "react";
import { memo } from "react";

import type { AgeVerificationMethodType } from "@jti/fe-common";
import { PERSONAL_INFORMATION } from "@jti/fe-common";

import { MethodType } from "./MethodType/MethodType";

type IMethodType = {
  methods: AgeVerificationMethodType[];
  selectedMethod: string;
  selectMethod: (selectedMethod: string) => void;
};

export const MethodSelection: FC<IMethodType> = memo(({ methods, selectedMethod, selectMethod }) => {
  const isSingleMethod = methods.length === 1;
  return (
    <>
      {methods
        .filter(({ code }) => code !== PERSONAL_INFORMATION)
        .map((method: AgeVerificationMethodType) => (
          <MethodType
            isSingleMethod={isSingleMethod}
            key={method.code}
            method={method}
            selectedMethod={selectedMethod}
            selectMethod={selectMethod}
          />
        ))}
    </>
  );
});
